import styled from 'styled-components';

export const ContainerGrid = styled.div`
  width: 100%;
  height: 100%;

  .grid .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;

export const SeparatorVertical = styled.div`
  width: 1px;
  height: 90px;
  margin-top: 10px;
  height: 95%;
  background-color: #ccc;
`;
